import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=6e241a66&"
import script from "./EditCategory.vue?vue&type=script&lang=js&"
export * from "./EditCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports